import StandaloneMessageService from '@/app-domains/messages/draft/writing.service'
import { detectImageBaseOnExtension } from '@/helpers/attachments'
import DisplayThumbnail from '@/components/PdfThumbnail/DisplayThumbnail.jsx'
import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon-2.svg'
import './style.scoped.sass'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import ModalContainer from '@/components/commons/Modal/Modal'
import MessageAttachmentsSectionViewer from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MessageAttachmentsSection/MessageAttachmentsSectionViewer/MessageAttachmentsSectionViewer'
import { useState } from 'react'
import classNames from 'classnames'

export default function Attachment ({ allAttachments, attachment, draftId, readOnly = false }) {
  const isUploading = attachment.isUploading
  const file_ext = attachment.filename.split('.').pop()

  const [showModal, setShowModal] = useState(false)

  async function deleteHandler () {
    await StandaloneMessageService.deleteAttachment(draftId, attachment.id)
  }

  function isImage (attachment) {
    if (attachment.mimetype) return attachment.mimetype.includes('image')
    return detectImageBaseOnExtension(attachment.filename)
  }

  function isPDF (attachment) {
    if (attachment.mimetype) return attachment.mimetype.includes('pdf')
    return file_ext === 'pdf'
  }

  // eslint-disable-next-line
  function getAttachmentPreview (attachment) {
    if (isImage(attachment)) return <img src={attachment.url || attachment.uri} alt={attachment.name} />
    if (isPDF(attachment)) {
      const getThumbNail = () => DisplayThumbnail({
        fileUrl: attachment.url || attachment.uri,
        pageIndex: 0
      })
      return (
        <div className='pdf-container'>
          {getThumbNail()}
        </div>
      )
    } else {
      return <span className="-icon">
        <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2"><path d="M38.869 0H3.763c-.978 0-1.77.655-1.77 1.926V55c0 .345.792 1 1.77 1h48.475c.977 0 1.77-.655 1.77-1V12.978c0-.696-.113-.92-.311-1.085L39.62.257c-.2-.164-.47-.257-.752-.257z" fill="#e9e9e0" fillRule="nonzero"></path><path d="M39.492.151V12h14.333L39.492.151z" fill="#d9d7ca" fillRule="nonzero"></path><path d="M52.238 56H3.763c-.978 0-1.77-.655-1.77-1.463V36.036l52.014-.061v18.562c0 .808-.792 1.463-1.77 1.463z" fill="currentColor" fillRule="nonzero"></path></svg>
        <span className="-icon_ext">{ file_ext }</span>
      </span>
    }
  }

  const parseFilename = (fileName) => {
    if (fileName.length >= 16) {
      const splitName = fileName.split('.')
      fileName = splitName[0].substring(0, 17) + '... .' + file_ext
    }
    return fileName
  }

  const closeModal = () => {
    // eslint-disable-next-line
    console.log('Triggering close modal')
    setShowModal(false)
  }
  
  return (
    <div className={classNames('message-modal-attachment', { extended: readOnly })} onClick={!isUploading ? () => setShowModal(true) : undefined}>
      <div className="message-modal-attachment-left">
        <div className='-title'>
          {parseFilename(attachment.filename)}
        </div>
        <div className="-weight">
          {isNaN(Math.round(attachment.filesize / 1000)) ? '' : `${Math.round(attachment.filesize / 1000)}KB`}
        </div>
      </div>
      { !readOnly && <>
        <div className="message-modal-attachment-right">
          {isUploading
            ? <div className="is-uploading-spinner"><LoadingSpinner size='small'/></div>
            : <div className="delete-container" onClick={deleteHandler}><TrashIcon/></div> }
        </div>
        { showModal && <ModalContainer
          showModal={showModal}
          modalType={'messageAttachmentViewer'}
          modalContent={
            <div>
              <MessageAttachmentsSectionViewer
                allAttachments={allAttachments}
                attachment={attachment}
                file_ext={file_ext}
                closeModal={() => setShowModal(false)}
              />
              <button className="-close-modal-attachment" onClick={closeModal}>
                <img src="assets/icons/arrow-left-solid.svg" />
              </button>
            </div>}
      />}
      </>}
    </div>
  )
}
